import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ChatPanelComponent } from './chat-panel/chat-panel.component';
import { OrderConversationsComponent } from './order-conversations/order-conversations.component';
import { AngularMaterialModule } from '@app/shared/angular-material.module';
import { SharedModule } from '@app/shared/shared.module';
import { MessagesPageComponent } from './messages-page/messages-page.component';
import { ChatConversationsListComponent } from './chat-conversations-list/chat-conversations-list.component';

@NgModule({
	declarations: [
		ChatConversationsListComponent,
		ChatPanelComponent,
		MessagesPageComponent,
		OrderConversationsComponent
	],
	imports: [
		CommonModule,
		AngularMaterialModule,
		FormsModule,
		SharedModule
	],
	exports: [
		ChatConversationsListComponent,
		OrderConversationsComponent
	]
})
export class MessagesModule { }
